export default [
  {
    questionText: "Who invites Steve and his friends to a cool kids party?",
    questionDifficulty: "1",
    questionImageUrl: "",
    questionTime: "",
    answers: [
      {
        text: "Roger",
        isCorrect: false
      },
      {
        text: "Snot",
        isCorrect: false
      },
      {
        text: "Mertz",
        isCorrect: true
      }
    ]
  },
  {
    questionText: "How many characters die in “100 A.D.”?",
    questionDifficulty: "2",
    questionImageUrl: "",
    questionTime: "",
    answers: [
      {
        text: "None",
        isCorrect: false
      },
      {
        text: "1",
        isCorrect: false
      },
      {
        text: "100",
        isCorrect: true
      }
    ]
  },
  {
    questionText:
      "What new food item does Francine buy for the Smith family that they go crazy for?",
    questionDifficulty: "2",
    questionImageUrl: "",
    questionTime: "",
    answers: [
      {
        text: "Zesty Pasta Sauce",
        isCorrect: true
      },
      {
        text: "Granola Bars",
        isCorrect: false
      },
      {
        text: "Instant Soup",
        isCorrect: false
      }
    ]
  },
  {
    questionText:
      "Which TV series does the Smith family discover contains a scavenger hunt?",
    questionDifficulty: "",
    questionImageUrl: "",
    questionTime: "",
    answers: [
      {
        text: "Star Wars",
        isCorrect: false
      },
      {
        text: "Breaking Bad",
        isCorrect: true
      },
      {
        text: "24",
        isCorrect: false
      }
    ]
  },
  {
    questionText: "Which member of the Smith family is a vegetarian?",
    questionDifficulty: "",
    questionImageUrl: "",
    questionTime: "",
    answers: [
      {
        text: "Hayle",
        isCorrect: true
      },
      {
        text: "Klaus",
        isCorrect: false
      },
      {
        text: "Steve",
        isCorrect: false
      }
    ]
  },
  {
    questionText:
      "Whose body does the Smith family hide in the woods on Christmas?",
    questionDifficulty: "",
    questionImageUrl: "",
    questionTime: "",
    answers: [
      {
        text: "Principal Lewis",
        isCorrect: false
      },
      {
        text: "Santa Claus",
        isCorrect: true
      },
      {
        text: "Klaus",
        isCorrect: false
      }
    ]
  },
  {
    questionText: "Who does Steve compete against in the spelling bee?",
    questionDifficulty: "",
    questionImageUrl: "",
    questionTime: "",
    answers: [
      {
        text: "Klaus",
        isCorrect: false
      },
      {
        text: "Snot",
        isCorrect: false
      },
      {
        text: "Akiko",
        isCorrect: true
      }
    ]
  },
  {
    questionText: "Who is one of the three creators of American Dad?",
    questionDifficulty: "",
    questionImageUrl: "",
    questionTime: "",
    answers: [
      {
        text: "Seth MacFarlane",
        isCorrect: true
      },
      {
        text: "Matt Groening",
        isCorrect: false
      },
      {
        text: "Vince Gilligan",
        isCorrect: false
      }
    ]
  },
  {
    questionText: "Who is Stan's boss in the CIA?",
    questionDifficulty: "",
    questionImageUrl: "",
    questionTime: "",
    answers: [
      {
        text: "Dick Reynolds",
        isCorrect: false
      },
      {
        text: "Avery Bullock",
        isCorrect: true
      },
      {
        text: "John Sanders",
        isCorrect: false
      }
    ]
  },
  {
    questionText: "Who is Steve's best friend?",
    questionDifficulty: "",
    questionImageUrl: "",
    questionTime: "",
    answers: [
      {
        text: "Klaus",
        isCorrect: false
      },
      {
        text: "Vince",
        isCorrect: false
      },
      {
        text: "Snot",
        isCorrect: true
      }
    ]
  }
];
